export default "__VITE_ASSET__DhhB_O7A__"